module.exports = __webpack_public_path__ + "img/ic_kebab.43f05eec.svg";